import { render, staticRenderFns } from "./TicketCategories.vue?vue&type=template&id=440a87e3&scoped=true&"
import script from "./TicketCategories.vue?vue&type=script&lang=js&"
export * from "./TicketCategories.vue?vue&type=script&lang=js&"
import style0 from "./TicketCategories.vue?vue&type=style&index=0&id=440a87e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a87e3",
  null
  
)

export default component.exports